import React, { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
} from "@mui/material";
import { useGet } from "../../../hooks/api-call";
import { Controller } from "react-hook-form";

const OrderBuyerSection = ({ onChange, initialValue, control, errors }) => {
  const [selectedBuyer, setSelectedBuyer] = useState(initialValue || {});

  const { responseData: buyers } = useGet(`buyers`);

  const handleChange = (buyer) => {
    const modifiedValue = {
      target: {
        name: "buyerId",
        value: buyer.buyerId,
      },
    };
    setSelectedBuyer(buyer);
    onChange(modifiedValue);
  };

  return (
    <Box>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid item xs={12} sm={4}>
          <FormControl fullWidth error={!!errors.buyerId} required>
            <InputLabel>Buyer</InputLabel>
            <Controller
              name="buyerId"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  label="Buyer"
                  value={field.value || ""}
                  onChange={(e) => {
                    const buyerId = e.target.value;
                    const buyer = buyers.find((buyer) => buyer.buyerId === buyerId);
                    field.onChange(buyerId); 
                    handleChange(buyer);
                  }}
                >
                  {buyers &&
                    buyers.map((buyer, index) => (
                      <MenuItem value={buyer.buyerId} key={index}>
                        {buyer?.buyerName}
                      </MenuItem>
                    ))}
                </Select>
              )}
            />
            <FormHelperText>
              {errors.buyerId && errors.buyerId.message}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Buyer Name"
            value={selectedBuyer?.buyerName || ""}
            InputProps={{ readOnly: true }}
            required
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="GST No"
            value={selectedBuyer?.gstNo || ""}
            InputProps={{ readOnly: true }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="PAN No"
            value={selectedBuyer?.panNo || ""}
            InputProps={{ readOnly: true }}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Contact No."
            value={selectedBuyer?.contactNo || ""}
            InputProps={{ readOnly: true }}
            type="tel"
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Email ID"
            value={selectedBuyer?.emailId || ""}
            InputProps={{ readOnly: true }}
          />
        </Grid>
      </Grid>

      <Box mt={2}>
        <TextField
          fullWidth
          label="Delivery Address"
          value={
            selectedBuyer.address
              ? `${selectedBuyer?.address || ""}, ${selectedBuyer?.locality || ""}, ${selectedBuyer?.district || ""}, ${selectedBuyer?.state || ""}, ${selectedBuyer?.pincode || ""}`
              : ""
          }
          InputProps={{ readOnly: true }}
        />
      </Box>
    </Box>
  );
};

export default OrderBuyerSection;
